// Shared TPB "value areas" — the matching spine the proof library, leads, and the message house
// all tag to. A proof metric is tagged by the area it *demonstrates*; a lead (later) by the area
// it *needs* (its pain). `leadPain` bridges to leads.solvable_pain_points for proof↔lead matching.
// Source of truth: docs/ops-program/cannabis-retail-pain-taxonomy.md

export interface ValueArea {
  slug: string;
  label: string;
  /** The lead pain id (leads.solvable_pain_points) this area maps to; null = operator-only value (no shopper pain). */
  leadPain: string | null;
}

export const VALUE_AREAS: ValueArea[] = [
  { slug: 'discovery', label: 'Discovery & education', leadPain: 'PAIN-DISCOVERY' },
  { slug: 'brand_ad_revenue', label: 'Brand-ad / co-op revenue', leadPain: null },
  { slug: 'throughput_labor', label: 'Throughput & labor', leadPain: 'PAIN-THROUGHPUT' },
  { slug: 'menu_compliance', label: 'Menu, price & compliance', leadPain: 'PAIN-MENU' },
  { slug: 'loyalty_retention', label: 'Loyalty & retention', leadPain: 'PAIN-LOYALTY' },
  { slug: 'fulfillment', label: 'In-store ordering / fulfillment', leadPain: 'PAIN-FULFILLMENT' },
  { slug: 'experience', label: 'Experience & differentiation', leadPain: 'PAIN-EXPERIENCE' },
  { slug: 'shopper_insight', label: 'Shopper insight & analytics', leadPain: 'PAIN-INSIGHT' },
];

export const VALUE_AREA_SLUGS: string[] = VALUE_AREAS.map((a) => a.slug);

const LABEL_BY_SLUG = new Map(VALUE_AREAS.map((a) => [a.slug, a.label]));

/** Human label for a value-area slug; falls back to the raw slug if unknown. */
export function valueAreaLabel(slug: string): string {
  return LABEL_BY_SLUG.get(slug) ?? slug;
}
